'use client';

import { Box, Fab } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useEffect, useState } from 'react';

const GoToTopButton = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <Box
      sx={{
        position: 'fixed',
        right: 16,
        bottom: 90,
        width: 60,
        height: 60,
        opacity: isScrolled ? 1 : 0,
        visibility: isScrolled ? 'visible' : 'hidden',
        transition: 'opacity 0.5s, visibility 0.5s',
        display: { xs: 'block', md: 'none' },
      }}
    >
      <Fab
        color='secondary'
        sx={{ background: '#808080 !important', color: 'white', width: '100%', height: '100%' }}
        title='Go To Top'
        onClick={handleClick}
      >
        <ArrowUpwardIcon></ArrowUpwardIcon>
      </Fab>
    </Box>
  );
};

export default GoToTopButton;
